<template>
    <div>
        <div class="modal is-active" v-show="showDeleteModal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
            <p class="modal-card-title">Delete Payroll</p>
            <button class="delete"  @click="cancel" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
            <!-- Content ... -->
            Are you sure do you want to delete this payroll permanently?
            </section>
            <footer class="modal-card-foot" style="justify-content:flex-end">
            <button :class="buttonDelete" @click="deletePermanently">Yes</button>
            <button class="button  is-small" @click="cancel">No</button>
            </footer>
        </div>
        </div>
    </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import axios from 'axios'
import AppToast from './../frontend/appToast'
import AppButton from './../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
    data: () => ({
        buttonDelete: appButton.isLoadingDanger(false)
    }),
    computed:{
        ...mapState('payroll',{
            showDeleteModal: state=>state.showDeleteModal,
            payroll: state=>state.payroll
        })
    },
    methods:{
        ...mapActions('payroll',[
            'openDeleteModal',
            'getPaginatedPayrolls'
        ]),
        deletePermanently(){
            if(this.payroll.payrollIds){ // multiple
                this.buttonDelete = appButton.isLoadingDanger(true)
                axios.post(`api/payrolls/delete-multiple-payrolls/`, this.payroll.payrollIds).then(response=>{
                    appToast.success(response.data)
                }).catch(error=>{
                    console.log(error)
                }).then(()=>{
                    this.default()
                    this.openDeleteModal({
                        showDeleteModal: false
                    })
                })
            }else{ // single
                this.buttonDelete = appButton.isLoadingDanger(true)
                axios.delete(`api/payrolls/${this.payroll.payrollId}`).then(response=>{
                    appToast.success(response.data)
                }).catch(error=>{
                    console.log(error)
                }).then(()=>{
                    this.default()
                    this.openDeleteModal({
                        showDeleteModal: false
                    })
                })
            }
        },
        cancel(){
            this.openDeleteModal({
                showDeleteModal: false
            })
        },
        default(){
            this.buttonDelete = appButton.isLoadingDanger(false)
            this.getPaginatedPayrolls({
                page: 1,
                pageSize: 10,
                query: ''
            })
        }
    }
}
</script>
